import React from 'react'
import Page from '../components/Page'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Form, FormFeedback, FormGroup, FormText, Input, Table, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup } from 'reactstrap'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from '../utils/posAxios'
import moment from 'moment-timezone'
import OrderItem from '../components/OrderItem'
import OrderPayment from '../components/OrderPayment'
import OrderTax from '../components/OrderTax'
import classnames from 'classnames'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import { MdDone, MdWarning, MdCancel, MdEmail, MdCameraAlt, MdClear, MdOutlineAttachEmail, MdContentPaste  } from 'react-icons/md'
import { FaEdit } from 'react-icons/fa'
import { getPayment, getPayment_v2 } from '../utils/dropdownlist'
import { SliderComponent } from '@syncfusion/ej2-react-inputs'
import update from 'immutability-helper'
import PosEasyParcelForm from '../components/PosEasyParcelForm'
import EasyParcelRequestOrder from '../components/EasyParcelRequestOrder'

class PosOrderDetailPage extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')
  access = StorageService.getSession('user_access')
  constructor(props) {
    super(props)
    let storeRole = this.access.store.find(x => x.store_id == this.props.match.params.id).role
    this.state = {
      isLoading: true,
      // isManageable:
      //   this.comp.Role === 'Superuser' ||
      //   this.comp.Role === 'Admin' ||
      //   this.comp.Role === 'Financial'
      //     ? true
      //     : false,
      // isManageablePayment:
      //   this.comp.Role === 'Manager' ||
      //   this.comp.Role === 'Superuser' ||
      //   this.comp.Role === 'Admin' ||
      //   this.comp.Role === 'Financial'
      //     ? true
      //     : false,
      isManageable: storeRole === 'Manager' || storeRole === 'Superuser' || storeRole === 'Admin' || storeRole === 'Supervisor' || storeRole === 'Financial' ? true : false,
      isManageablePayment: storeRole === 'Manager' || storeRole === 'Superuser' || storeRole === 'Admin' || storeRole === 'Supervisor' || storeRole === 'Financial' ? true : false,
      addressModal: false,
      billingModal: false,
      confirmModal: false,
      removeImageModal: false,
      imageModal: false,
      uploadImageModal: false,
      invoiceModal: false,
      scheduleModal: false,
      remarkModal: false,
      emailModal: false,
      paymentModal: false,
      shipmentModal: false,
      discountModal: false,
      dataModal: false,
      referenceModal: false,
      tabList: [{ name: 'Item' }, { name: 'Payment' }, { name: 'Tax' }],
      stateList: [],
      color: '',
      activeTab: '1',
      order_id: this.props.match.params.order_id,
      store_id: this.props.match.params.id,
      order_type: '',
      service_type: '',
      total_price: '',
      total_rounding: '',
      total_paid: '',
      total_outstanding: '',
      total_discount: '',
      total_tax: '',
      remarks: '',
      edit_remarks: '',
      itemcount: '',
      order_status: '',
      payment_status: '',
      data: '',
      order_by: '',
      order_dt: '',
      order_time: '',
      updated_dt: '',
      payment_items: '',
      items: '',
      tax_items: '',
      invoice_no: '',
      invoice_dt: '',
      edit_invoice_no: '',
      email: '',
      schedule: {},
      address: {},
      billing: {},
      editaddress: {
        address: '',
        unit: '',
        country: '',
        postal_code: '',
        contact: '',
        name: '',
        email: '',
        order_msg: '',
      },
      editbilling: {
        address: '',
        unit: '',
        country: '',
        postal_code: '',
        contact: '',
        name: '',
        email: '',
        billing_msg: '',
        payment_mode: '',
      },
      schedule_date: moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      schedule_slot: '',
      schedule_option: [],
      payment_data: '',
      payment_reference: '',
      payment_id: '',
      payment_type: '',
      payment_amount: '',
      paymentList: [],
      send_receipt: 0,
      fileList: [],
      selectedID: '',
      selectedData: '',
      b64image: '',
      isImage: false,
      followup: '',
      invoice_verify: '',
      edit_discount: '',
      tracking: { provider: '', tracking_no: '', url: '', remarks: '' },
      edit_tracking: {},
      delivery_ezp_list: [],
      ezpdetailModal: false,
      deliveryezpModal: false,
      customer_id: '',
      customer_email: '',
      customerModal: false,
      customer_email_list: [],
      edit_customer_id: '',
      customer_email_search: '',
      orderDateModal: false,
      order_edit_data: [],
    }
  }

  componentDidMount() {
    this.getOrderDetail()
    //this.getOrderReceipt()
    this.getOrderState()
    this.getOrderFile()
    this.getPaymentList()
    this.getDeliveryEzp()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  checkboxChangeHandler = event => {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    })
    this.orderFollowUp(!this.state[event.target.name])
  }

  getPaymentList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
    }

    axios
      .post(url + ':3001/v1/store/payment', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({ paymentList: result.data })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getDeliveryEzp = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
      order_id: this.state.order_id,
    }

    axios
      .post(url + ':3003/v1/order/delivery/ezp', data)
      .then(response => {
        const result = response.data
        // if (result.error == true && result.message != 'Success') {
        //   alert(result.message)
        //   return
        // }
        if (this._isMounted) {
          this.setState({ delivery_ezp_list: result.data.length ? result.data : [] })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  ezpPayment = ezp_order_no => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      ezp_order_no: ezp_order_no,
    }

    axios
      .post(url + ':3003/v1/order/delivery/ezp/payment', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.messagenow == 'Payment Done') {
            alert(result.data.messagenow)
            window.location.reload()
          }
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  ezpWayBill = ezp_order_no => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      ezp_order_no: ezp_order_no,
    }

    axios
      .post(url + ':3003/v1/order/delivery/ezp/waybill', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.parcel.length > 0) {
            let { awb_id_link } = result.data.parcel[0]
            if (awb_id_link.length > 0 && awb_id_link != undefined) {
              window.open(awb_id_link, '_blank')
            } else {
              throw new Error('Error generating waybill')
            }
          } else {
            throw new Error('Error generating waybill')
          }
        }
      })
      .catch(error => {
        if (error.hasOwnProperty('message') && error.message == 'Error generating waybill') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: error.message,
            level: 'error',
            position: 'br',
            autoDismiss: 2,
            dismissible: 'click',
          })
        } else {
          alert(error)
        }
      })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      deliveryezpModal: false,
      customerModal: false,
    })

    if (reload) {
      //this.getDeliveryEzp()
      window.location.reload()
    }
  }

  scheduleModal = () => () => {
    return this.setState({
      scheduleModal: !this.state.scheduleModal,
      schedule_date: this.state.schedule != null ? moment(this.state.schedule.schedule_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),

      schedule_slot: this.state.schedule != null ? this.state.schedule.slot_id : '',
    })
  }

  toggleOrderDateModal = () => () => {
    return this.setState({
      orderDateModal: !this.state.orderDateModal,
    })
  }

  customerModal = () => () => {
    return this.setState({
      customerModal: !this.state.customerModal,
      edit_customer_id: '',
      customer_email_list: [],
    })
  }

  addressModal = () => () => {
    return this.setState({
      addressModal: !this.state.addressModal,
      editaddress: this.state.address,
    })
  }

  billingModal = () => () => {
    return this.setState({
      billingModal: !this.state.billingModal,
      editbilling: this.state.billing,
    })
  }

  addressHandler = e => {
    let { id, name, value } = e.target
    this.setState({
      [id]: update(this.state[id], { [name]: { $set: value } }),
    })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  invoiceModal = () => () => {
    return this.setState({
      invoiceModal: !this.state.invoiceModal,
      edit_invoice_no: this.state.invoice_no,
    })
  }

  remarkModal = () => () => {
    if (this.state.isManageable) {
      return this.setState({
        remarkModal: !this.state.remarkModal,
        edit_remarks: this.state.remarks,
      })
    }
  }

  emailModal = () => () => {
    return this.setState({
      emailModal: !this.state.emailModal,
      email: this.state.billing ? this.state.billing.email : '',
    })
  }

  openPdf = () => () => {
    let pdf_link = `https://unityapi2.pseudoscops.com/topdf.php?d=${this.state.ekey}`
    window.open(pdf_link, '_blank')
  }

  openPdf2 = () => () => {
    //let pdf_link = `https://unityapi2.pseudoscops.com/topdf.php?d=${this.state.ekey}`
    //window.open(pdf_link, '_blank')

    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
    }

    axios.post(url + ':3003/v1/order/do/key', data)
    .then(response => {
      //console.log(response.data);
      const result = response.data;
      if (result.error == true && result.message != 'Success') {
        alert(result.message)
        return
      }
      //let pdf_link = `https://unityapi2.pseudoscops.com/topdf_ch.php?d=${result.data}`;
      //let pdf_link = `https://unityapi2.pseudoscops.com:3051/v1/pdf/export/${result.data}`;
      let pdf_link = `https://unityapi2.pseudoscops.com:3051/v1/pdf/export/view/${result.data}`;
      //console.log(pdf_link);
      window.open(pdf_link, '_blank');
    }).catch(error => {
      console.log(error);
    });


  }

  paymentModal = () => () => {
    if (this.state.isManageablePayment) {
      return this.setState({
        paymentModal: !this.state.paymentModal,
        payment_amount: this.state.total_outstanding,
        payment_type: '',
        payment_reference: '',
        payment_data: '',
        send_receipt: 0,
      })
    }
  }

  shipmentModal = () => () => {
    if (this.state.isManageablePayment) {
      return this.setState({
        shipmentModal: !this.state.shipmentModal,
        edit_tracking: this.state.tracking,
      })
    }
  }

  ezpdetailModal =
    (order_detail = {}) =>
    () => {
      return this.setState({
        ezpdetailModal: !this.state.ezpdetailModal,
        epz_order_detail: order_detail,
      })
    }

  deliveryezpModal =
    (reload = false) =>
    () => {
      if (reload) {
        this.getDeliveryEzp()
      }
      return this.setState({
        deliveryezpModal: !this.state.deliveryezpModal,
      })
    }

  discountModal = () => () => {
    if (this.state.isManageablePayment) {
      return this.setState({
        discountModal: !this.state.discountModal,
        edit_discount: this.state.total_discount,
      })
    }
  }

  confirmModal = () => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
    })
  }

  imageModal = data => () => {
    return this.setState({
      imageModal: !this.state.imageModal,
      selectedData: data,
    })
  }

  removeImageModal = id => () => {
    return this.setState({
      removeImageModal: !this.state.removeImageModal,
      selectedID: id ? id : '',
    })
  }

  uploadImageModal = id => () => {
    return this.setState({
      uploadImageModal: !this.state.uploadImageModal,
      selectedID: id ? id : '',
    })
  }

  dataModal = (id, value) => () => {
    return this.setState({
      dataModal: !this.state.dataModal,
      payment_data: value,
      payment_id: id,
    })
  }

  referenceModal = (id, value) => () => {
    return this.setState({
      referenceModal: !this.state.referenceModal,
      payment_reference: value,
      payment_id: id,
    })
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  shipmentHandler = e => {
    const { name, value } = e.target
    this.setState({
      edit_tracking: update(this.state.edit_tracking, {
        [name]: { $set: value },
      }),
    })
  }

  statusHandler = e => {
    const { name, value } = e.target

    if (value === 'Cancelled') {
      this.setState({
        confirmModal: !this.state.confirmModal,
      })
    } else if (value === 'In Progress' || value === 'Scheduled') {
      if (this.state.schedule !== null) {
        this.setState({
          [name]: value,
        })
        this.status(value)
      } else {
        this.notificationSystem.addNotification({
          title: <MdWarning />,
          message: 'Please set schedule first.',
          level: 'warning',
          position: 'tc',
          autoDismiss: 4,
          dismissible: 'click',
        })
      }
    } else {
      this.setState({
        [name]: value,
      })
      this.status(value)
    }
  }

  scheduleHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    if (name === 'schedule_date') {
      this.getSchedule()
    }

    if (name === 'schedule_slot') {
    }
  }

  getOrderDetail() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
    }

    axios
      .post(url + ':3003/v1/order/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {

          let orderDatetime = '';
          if (result.data.order_dt) {
            orderDatetime = result.data.order_dt;
            result.data.order_dt = moment(result.data.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
          }
          if (result.data.updated_dt) {
            result.data.updated_dt = moment(result.data.updated_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
          }
          if (result.data.total_tax) {
            result.data.total_tax = parseFloat(result.data.total_tax).toFixed(2)
          }

          let emptyAddress = {
            name: '',
            email: '',
            contact: '',
            unit: '',
            address: '',
            postal_code: '',
            country: '',
            order_msg: '',
          }

          this.setState({
            order_type: result.data.order_type,
            service_type: result.data.service_type,
            total_price: result.data.total_price,
            total_rounding: result.data.total_rounding,
            total_paid: result.data.total_paid,
            total_outstanding: result.data.total_outstanding,
            total_discount: result.data.total_discount,
            total_tax: result.data.total_tax,
            remarks: result.data.remark,
            itemcount: result.data.itemcount,
            order_status: result.data.order_status,
            payment_status: result.data.payment_status,
            data: result.data.data,
            order_by: result.data.order_by,
            order_dt: result.data.order_dt,
            full_order_datetime: orderDatetime,
            updated_dt: result.data.updated_dt,
            payment_items: result.data.payment_items,
            items: result.data.items,
            tax_items: result.data.tax_items,
            invoice_no: result.data.invoice_no,
            invoice_dt: result.data.invoice_dt,
            schedule: result.data.schedule,
            address: result.data.address ? result.data.address : emptyAddress,
            billing: result.data.billing,
            followup: result.data.followup,
            tracking: result.data.tracking ? result.data.tracking : { provider: '', tracking_no: '', url: '', remarks: '' },
            isLoading: false,
            invoice_verify: result.data.invoice_verify,
            customer_id: result.data.customer != null && result.data.customer.customer_id,
            customer_email: result.data.customer != null && result.data.customer.email,
            order_edit_data: result.data.order_edit_data,
          })
        }
      })
      .then(() => {
        this.getSchedule()
      })
      .catch(error => {
        alert(error)
      })
  }

  getOrderReceipt() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
    }
    //console.log(data);

    axios
      .post(url + ':3003/v1/order/receipt/key', data)
      .then(response => {
        const result = response.data
        //console.log(result);
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            ekey: result.data,
          })
        }
        let pdf_link = `https://unityapi2.pseudoscops.com/topdf.php?d=${result.data}`
        window.open(pdf_link, '_blank')
      })
      .catch(error => {
        alert(error)
      })
  }

  getOrderState() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3003/v1/order/state', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            stateList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getSchedule() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      date: this.state.schedule_date,
      type: this.state.service_type,
    }

    axios
      .post(url + ':3001/v2/store/schedule/daily', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            schedule_option: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  orderFollowUp(followup) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: this.state.order_id,
      store_id: this.state.store_id,
      followup: followup ? '1' : '0',
      updated_by: user.email,
    }
    console.log(this.state)
    axios
      .post(url + ':3003/v1/order/followup/set', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        let message = this.state.followup ? 'Order followed up' : 'Order remove follow up'
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: message,
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  getOrderFile() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
    }

    axios
      .post(url + ':3003/v1/order/file', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            fileList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  removeImage() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      file_id: this.state.selectedID,
      delete_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/file/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Image removed successfully',
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })
        this.setState({
          removeImageModal: false,
        })
        this.getOrderFile()
      })
      .catch(error => {
        alert(error)
      })
  }

  uploadImage = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: this.state.order_id,
      store_id: this.state.store_id,
      file_type: 'image',
      b64image: this.state.b64image.split(',')[1],
      user: user.email,
    }

    if (this.state.isImage) {
      axios
        .post(url + ':3003/v1/order/file/add', data)
        .then(response => {
          const result = response.data
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: 'Image uploaded successfully',
            level: 'success',
            position: 'br',
            autoDismiss: 2,
            dismissible: 'click',
          })
          this.setState({
            uploadImageModal: false,
          })
          this.getOrderFile()
        })
        .catch(error => {
          alert(error)
        })
    } else {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Please select valid photo.',
        level: 'error',
        position: 'br',
        autoDismiss: 2,
        dismissible: 'click',
      })
    }
  }

  imageChangeHandler = event => {
    let reader = new FileReader()
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0]
      console.log(file)
      if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {
        this.notificationSystem.addNotification({
          title: <MdWarning />,
          message: 'Please select valid photo.',
          level: 'error',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })
        // this.setState({
        //   isImage: false,
        // });
      } else {
        reader.onloadend = () => {
          this.setState({
            b64image: reader.result,
            isImage: true,
          })
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Photo has been uploaded.',
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })

        reader.readAsDataURL(file)
      }
    }
  }

  invoice = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      invoice: this.state.edit_invoice_no,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/invoice', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Invoice updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ invoiceModal: false })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  remarks = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      remarks: this.state.edit_remarks,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/remarks', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Remark updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ remarkModal: false })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  email = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      email: this.state.email,
    }

    axios
      .post(url + ':3003/v1/order/receipt', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Email sent successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ emailModal: false })
      })
      .catch(error => {
        alert(error)
      })
  }

  updateOrderDate = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      order_dt: this.state.order_dt,
      company_id: comp.CompanyID,
      updated_by: user.email,
      old_order_dt: this.state.full_order_datetime
    }

    axios
      .post(url + ':3003/v1/order/date/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Order date updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ orderDateModal: false })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  schedule = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let schedule = this.state.schedule_option.find(x => x.slot_id == this.state.schedule_slot)

    let schedule_data = {
      schedule_date: moment(this.state.schedule_date).tz('Asia/Singapore').format('DD/MM/YYYY'),
      slot_id: schedule.slot_id,
      starttime: schedule.starttime,
      endtime: schedule.endtime,
    }

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      schedule: schedule_data,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/schedule/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Schedule updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ scheduleModal: false })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  address = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      address: this.state.editaddress,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/address/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Address updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ addressModal: false })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  billing = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      billing: this.state.editbilling,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/billing/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Billing Address updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ billingModal: false })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  status = value => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.order_id,
      status: value,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/status', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdWarning />,
            message: result.message,
            level: 'error',
            position: 'tc',
            autoDismiss: 4,
            dismissible: 'click',
          })
          this.setState({
            order_status: 'Attention',
          })
          return
        }

        if (value == 'Completed') {
          if (this.state.schedule != null) {
            let today = moment().tz('Asia/Singapore').format('MM/DD/YYYY')
            if (this.state.schedule.schedule_date != today) {
              // alert(`Please note that Schedule Completion Date for this Order is ${this.state.schedule.schedule_date}`)
              this.notificationSystem.addNotification({
                title: <MdWarning />,
                message: `Please note that Schedule Completion Date for this Order is ${this.state.schedule.schedule_date}`,
                level: 'info',
                position: 'tc',
                autoDismiss: 5,
                dismissible: 'click',
              })
            }
          }
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Status updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.getOrderDetail()
        if (value === 'Cancelled') {
          this.setState({ confirmModal: false })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  paymentData = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      payment_id: this.state.payment_id,
      data: this.state.payment_data,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/payment/data', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Remark updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ dataModal: false, payment_data: '' })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  discount = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: this.state.order_id,
      store_id: this.state.store_id,
      discount: this.state.edit_discount,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/discount/set', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Remark updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ discountModal: false, edit_discount: '' })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  paymentReference = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      payment_id: this.state.payment_id,
      reference: this.state.payment_reference,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/payment/reference', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Reference updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ referenceModal: false, payment_reference: '' })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  payment = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let payment = this.state.paymentList.find(x => x.id == this.state.payment_type)

    let payment_item = {
      payment_id: this.makeid(20),
      payment_type_id: payment.id,
      payment_type: payment.name,
      amount: this.state.payment_amount,
      data: this.state.payment_data,
      reference: this.state.payment_reference,
    }

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: this.state.order_id,
      store_id: this.state.store_id,
      send_receipt: this.state.send_receipt ? '1' : '0',
      payment_item: payment_item,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v2/order/payment/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Reference updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({
          paymentModal: false,
          payment_data: '',
          payment_reference: '',
          payment_amount: '',
        })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  shipment = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let { provider, tracking_no, url: tURL, remarks } = this.state.edit_tracking
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: this.state.order_id,
      store_id: this.state.store_id,
      provider: provider,
      tracking_no: tracking_no,
      url: tURL,
      remarks: remarks,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/tracking', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Shipment Tracking updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({
          shipmentModal: false,
        })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  makeid(length) {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  order = id => {
    this.props.history.push({
      pathname: '/posorder/store/' + this.state.store_id + '/' + id,
    })
  }

  clearCustomerEmailList = () => {
    this.setState({
      customer_email_list: [],
    })
  }

  searchCustomerEmail = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      email: this.state.customer_email_search,
    }

    axios
      .post(url + ':3003/v1/order/customer/search', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdWarning />,
            message: result.message,
            level: 'error',
            position: 'tc',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        if (this._isMounted) {
          this.setState({
            customer_email_list: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  updateCustomerEmail = customer_id => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      customer_id: customer_id,
      order_id: this.state.order_id,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/customer/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdWarning />,
            message: result.message,
            level: 'error',
            position: 'tc',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Customer Email updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ customerModal: false })
        this.getOrderDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  editOrderOnClick = (store_id, order_id) => {
    console.log('edit order')
    this.props.history.push({
      pathname: '/posorder/store/' + store_id + '/reorder/' + order_id,
      state: { id: order_id },
    })
  }

  render() {
    const { activeTab, stateList, isLoading, order_status } = this.state
    const order_company = StorageService.getSession('selected_org')
    let color = ''
    if (this.state.stateList.length && this.state.order_status) {
      color = this.state.stateList.find(x => x.name == this.state.order_status).color_code
    }
    let maxRange = 1,
      currentRange = 0
    if (stateList.length > 0 && !isLoading) {
      maxRange = stateList.find(x => x.name === 'Completed').order_index
      if (order_status != 'Cancelled' && order_status != 'Attention') {
        currentRange = stateList.find(x => x.name === order_status).order_index
      }
    }
    let path = [
      {
        name: 'Store',
        active: false,
        path: '/posorder',
      },
      {
        name: 'Order',
        active: false,
        path: '/posorder/store/' + this.state.store_id,
      },
      { name: 'Detail', active: true, path: '' },
    ]
    if (this.props.history.location.state && this.props.history.location.state.prevPath == '/posreport') {
      path = [{ name: 'Report', active: false, path: '/posreport' }, , { name: 'Detail', active: true, path: '' }]
    }

    const orderTime = moment(this.state.full_order_datetime).tz('Asia/Singapore').format("hh:mm A");
console.log(this.state.full_order_datetime)
console.log(orderTime)
    return (
      <Page className="PosOrderDetailPage" title="Order Detail" breadcrumbs={path}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Row>
          <Col className="ps-flex v-center">
            <Input style={{ background: color, color: 'white', width: 'auto' }} type="select" name="order_status" onChange={this.statusHandler} value={this.state.order_status} disabled={!this.state.isManageable ? true : false}>
              {this.state.stateList.map(item => {
                if (order_status === 'Completed') {
                  if (item.name === 'Cancelled' || item.name === 'Completed') {
                    return (
                      <option className="ps-width-auto" key={item.id} value={item.name} style={{ background: item.color_code, color: 'white' }}>
                        {item.name}
                      </option>
                    )
                  }
                }
                // else if (order_status === 'Quotation') {
                //   if (item.name === 'Cancelled' || item.name === 'Quotation') {
                //     return (
                //       <option className="ps-width-auto" key={item.id} value={item.name} style={{ background: item.color_code, color: 'white' }}>
                //         {item.name}
                //       </option>
                //     )
                //   }
                // }
                else {
                  return (
                    <option className="ps-width-auto" key={item.id} value={item.name} style={{ background: item.color_code, color: 'white' }}>
                      {item.name}
                    </option>
                  )
                }
              })}
            </Input>
            <Button color="link" onClick={this.emailModal()}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <MdEmail size={36} />
              </IconContext.Provider>
            </Button>

            <Button color="link" onClick={() => this.getOrderReceipt()} style={{ marginTop: '5px' }}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <MdOutlineAttachEmail size={34} />
              </IconContext.Provider>
            </Button>

            {/* <Button
              color={this.state.followup ? 'success' : 'danger'}
              onClick={() => this.orderFollowUp()}
            >
              Follow Up
            </Button> */}
            <FormGroup check>
              <Label check>
                <Input type="checkbox" name="followup" checked={this.state.followup} onChange={this.checkboxChangeHandler} /> Follow Up
              </Label>
            </FormGroup>

            <Button color="link" onClick={this.openPdf2()} style={{ marginTop: '5px' }}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <MdContentPaste  size={34} />
              </IconContext.Provider>
            </Button>
          </Col>
        </Row>

        <Row>
          <Col sm="12" md={{ size: 6, offset: 3 }}>
            <div className="sliderwrap">
              <SliderComponent value={currentRange} max={maxRange} type="MinRange" readonly={true} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Order Information</CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={3}>
                    <Label>Order ID</Label>
                    <p>
                      {this.state.order_id}
                      <img src={`https://image-charts.com/chart?cht=qr&chld=H|1&chs=100x100&chl=${this.state.order_id}`} />
                    </p>
                  </Col>
                  <Col lg={3}>
                    <Label>Order Type</Label>
                    <p>{this.state.order_type}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Service Type</Label>
                    <p>{this.state.service_type}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Order Date</Label>
                    <Button color="link" style={{ padding: '2px 0px 5px 5px' }} onClick={this.toggleOrderDateModal()}>
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <FaEdit size={16} />
                      </IconContext.Provider>
                    </Button>
                    <p>{this.state.order_dt}</p>
                    <span>{orderTime}</span>
                  </Col>
                  <Col lg={3}>
                    <Label>Invoice No.</Label>
                    {/* <Button
                      color="link"
                      style={{ padding: '2px 0px 5px 5px' }}
                      onClick={this.invoiceModal()}
                    >
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <FaEdit size={16} />
                      </IconContext.Provider>
                    </Button> */}
                    <p>{this.state.invoice_no}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Invoice Date</Label>
                    {/* <Button
                      color="link"
                      style={{ padding: '2px 0px 5px 5px' }}
                      onClick={this.invoiceModal()}
                    >
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <FaEdit size={16} />
                      </IconContext.Provider>
                    </Button> */}
                    <p>{this.state.invoice_dt}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Verified</Label>
                    <p>
                      <span className={'ps-indicator ' + (this.state.invoice_verify == '1' ? 'on' : 'off')}>{this.state.invoice_verify == '1' ? 'Yes' : 'No'}</span>
                    </p>
                  </Col>
                  <Col lg={3}>
                    <Label>Processed By</Label>
                    <p>{this.state.order_by}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {this.state.customer_id != '' && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display">
                <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                  Customer Information
                  {/* <ButtonGroup>
                    <Button className="theme-button unity-theme-button-transparent" onClick={this.deliveryezpModal()}>
                      Create
                    </Button>
                  </ButtonGroup> */}
                </CardHeader>
                <CardBody>
                  <Row form>
                    <Col lg={12}>
                      <Label>Email</Label>
                      <p>
                        {this.state.customer_email}{' '}
                        <Button color="link" style={{ padding: '2px 0px 5px 5px' }} onClick={this.customerModal()}>
                          <IconContext.Provider value={{ color: '#2a2c6b' }}>
                            <FaEdit size={16} />
                          </IconContext.Provider>
                        </Button>
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {(this.state.service_type === 'Self Collection' || this.state.service_type === 'Delivery' || this.state.service_type === 'Service Order' || this.state.service_type === 'Direct Order') && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display">
                <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">{this.state.service_type}</CardHeader>
                <CardBody>
                  <Row form>
                    {this.state.schedule != null && (
                      <Col lg={12}>
                        <Label>Schedule</Label>
                        <Button color="link" style={{ padding: '2px 0px 5px 5px' }} onClick={this.scheduleModal()}>
                          <IconContext.Provider value={{ color: '#2a2c6b' }}>
                            <FaEdit size={16} />
                          </IconContext.Provider>
                        </Button>
                        <p>{this.state.schedule.schedule_date + ', ' + this.state.schedule.starttime + ' - ' + this.state.schedule.endtime}</p>
                      </Col>
                    )}

                    {/* {this.state.service_type === 'Self Collection' && (
                      <>
                        <Col lg={12}>
                          <Label>Billing Info</Label>
                        </Col>
                        <Col lg={3}>
                          <Label>Name</Label>
                          <p>{this.state.billing.name}</p>
                        </Col>
                        <Col lg={3}>
                          <Label>Contact</Label>
                          <p>{this.state.billing.contact}</p>
                        </Col>
                        <Col lg={3}>
                          <Label>Email</Label>
                          <p>{this.state.billing.email}</p>
                        </Col>
                        <Col lg={3}>
                          <Label>Message</Label>
                          <p>{this.state.billing.msg}</p>
                        </Col>
                        <Col lg={3}>
                          <Label>Payment Mode</Label>
                          <p>{this.state.billing.payment_mode}</p>
                        </Col>
                      </>
                    )} */}

                    {(this.state.service_type === 'Delivery' || this.state.service_type === 'Self Collection' || this.state.service_type === 'Service Order' || this.state.service_type === 'Direct Order') && (
                      <>
                        <Col lg={12}>
                          <Label>Address Info</Label>
                          <Button color="link" style={{ padding: '2px 0px 5px 5px' }} onClick={this.addressModal()}>
                            <IconContext.Provider value={{ color: '#2a2c6b' }}>
                              <FaEdit size={16} />
                            </IconContext.Provider>
                          </Button>
                          <Row>
                            <Col lg={3}>
                              <Label>Name</Label>
                              <p>{this.state.address.name}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Email</Label>
                              <p>{this.state.address.email}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Contact</Label>
                              <p>{this.state.address.contact}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Address</Label>
                              <p>{this.state.address.address}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Unit</Label>
                              <p>{this.state.address.unit}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Postal Code</Label>
                              <p>{this.state.address.postal_code}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Country</Label>
                              <p>{this.state.address.country}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Order Message</Label>
                              <p>{this.state.address.order_msg}</p>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={12}>
                          <Label>Billing Info</Label>
                          <Button color="link" style={{ padding: '2px 0px 5px 5px' }} onClick={this.billingModal()}>
                            <IconContext.Provider value={{ color: '#2a2c6b' }}>
                              <FaEdit size={16} />
                            </IconContext.Provider>
                          </Button>
                          <Row>
                            <Col lg={3}>
                              <Label>Name</Label>
                              <p>{this.state.billing.name}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Email</Label>
                              <p>{this.state.billing.email}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Contact</Label>
                              <p>{this.state.billing.contact}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Address</Label>
                              <p>{this.state.billing.address}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Unit</Label>
                              <p>{this.state.billing.unit}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Postal Code</Label>
                              <p>{this.state.billing.postal_code}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Country</Label>
                              <p>{this.state.billing.country}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Payment Mode</Label>
                              <p>{this.state.billing.payment_mode}</p>
                            </Col>
                            <Col lg={3}>
                              <Label>Order Message</Label>
                              <p>{this.state.billing.billing_msg}</p>
                            </Col>
                          </Row>
                        </Col>
                      </>
                    )}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                EasyParcel
                <ButtonGroup>
                  <Button className="theme-button unity-theme-button-transparent" onClick={this.deliveryezpModal()}>
                    Create
                  </Button>
                </ButtonGroup>
              </CardHeader>
              <CardBody>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Order No.</th>
                      <th>Order Status</th>
                      <th>Pickup Date</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.delivery_ezp_list.length > 0 &&
                      this.state.delivery_ezp_list.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.order_no}</td>
                            <td>{item.order_status}</td>
                            <td>{item.order_detail.collect_date}</td>
                            <td>{item.remarks}</td>
                            <td>
                              <div className="ps-action-button">
                                <Button className="theme-button unity-theme-button-primary" onClick={this.ezpdetailModal(item.order_detail)}>
                                  Detail
                                </Button>
                                {item.order_payable == 'True' && (
                                  <Button className="theme-button unity-theme-button-primary" onClick={() => this.ezpPayment(item.order_no)}>
                                    Payment
                                  </Button>
                                )}
                                {item.order_status == 'Paid' && (
                                  <Button className="theme-button unity-theme-button-primary" onClick={() => this.ezpWayBill(item.order_no)}>
                                    Waybill
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Shipment Tracking
                <ButtonGroup>
                  <Button className="theme-button unity-theme-button-transparent" onClick={this.shipmentModal()}>
                    Edit
                  </Button>
                </ButtonGroup>
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col>
                    <Label>Provider</Label>
                    <p>{this.state.tracking.provider}</p>
                  </Col>
                  <Col>
                    <Label>Tracking No.</Label>
                    <p>{this.state.tracking.tracking_no}</p>
                  </Col>
                  <Col>
                    <Label>URL</Label>
                    <p>{this.state.tracking.url}</p>
                  </Col>
                  <Col>
                    <Label>Remarks</Label>
                    <p>{this.state.tracking.remarks}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                {this.state.payment_status}
                {this.state.payment_status === 'Pending Payment' && (
                  <ButtonGroup>
                    <Button className="theme-button unity-theme-button-transparent" onClick={this.discountModal()}>
                      Adjust Discount
                    </Button>
                  </ButtonGroup>
                )}
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col>
                    <Label>Price($)</Label>
                    <p>{this.state.total_price}</p>
                  </Col>
                  <Col>
                    <Label>Discount($)</Label>
                    <p>{this.state.total_discount}</p>
                  </Col>
                  <Col>
                    <Label>Tax($)</Label>
                    <p>{this.state.total_tax}</p>
                  </Col>
                  <Col>
                    <Label>Paid($)</Label>
                    <p>{this.state.total_paid}</p>
                  </Col>
                  <Col>
                    <Label>Outstanding($)</Label>
                    <p>{this.state.total_outstanding}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="ps-bg-gradient">
                Remark (Internal){' '}
                <Button color="link" style={{ padding: '2px 0px 7px 5px' }} onClick={this.remarkModal()}>
                  <IconContext.Provider value={{ color: 'white' }}>
                    <FaEdit size={16} />
                  </IconContext.Provider>
                </Button>
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col>
                    <p>{this.state.remarks ? this.state.remarks : 'None'}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString())
                          }}>
                          {item.name}
                        </NavLink>
                      </NavItem>
                    )
                  })}
                </Nav>

                {this.state.store_id && (
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      {(this.state.store_id == 271 || this.state.store_id == 270) && order_status != 'In Progress' && order_status != 'Completed' && order_status != 'Cancelled' && (
                        <div className="mb-2" align="right">
                          <Button className="theme-button theme-button-secondary" type="button" onClick={() => this.editOrderOnClick(this.state.store_id, this.state.order_id)}>
                            Edit Item
                          </Button>
                        </div>
                      )}
                      <OrderItem state={this.state} />
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <OrderPayment dataModal={this.dataModal} referenceModal={this.referenceModal} paymentModal={this.paymentModal} state={this.state} />
                    </TabPane>
                    <TabPane tabId="3" className="py-3">
                      <OrderTax state={this.state} />
                    </TabPane>
                  </TabContent>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        {(this.state.service_type === 'Delivery Order' || this.state.service_type === 'Service Order') && this.state.data && (
          <Row>
            <Col>
              <Card>
                <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Delivery Information</CardHeader>
                <CardBody>
                  <Row form>
                    <Col lg={4}>
                      <Label>Signature</Label>
                      {/* <img src={JSON.parse(this.state.data).signature} /> */}
                      <img style={{ width: 'inherit' }} src={`data:image/png;base64,${JSON.parse(this.state.data).signature}`} />
                    </Col>
                    <Col lg={8}>
                      <Label>Comment</Label>
                      <p>{JSON.parse(this.state.data).comments}</p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Images
                <ButtonGroup>
                  <Button className="theme-button theme-button-secondary" onClick={this.uploadImageModal()} disabled={!this.state.isManageable}>
                    <MdCameraAlt />
                    Upload
                  </Button>
                </ButtonGroup>
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col md={12}>
                    <div className=" ps-photo">
                      {this.state.fileList.map(i => {
                        return (
                          <div className="image" key={i.id}>
                            <MdCancel className="remove" onClick={this.removeImageModal(i.id)} />
                            <img src={i.file} onClick={this.imageModal(i.file)} />
                          </div>
                        )
                      })}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Edit Data</CardHeader>
              <CardBody>
                <Table responsive hover className="ps-table tb-col-2">
                  <thead>
                    <tr>
                      <th>Updated By</th>
                      <th>Datetime</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.order_edit_data.length > 0 &&
                      this.state.order_edit_data.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.updated_by}</td>
                            <td>{moment(item.datetime).tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss')}</td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={this.state.invoiceModal} toggle={this.invoiceModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.invoice}>
            <ModalHeader toggle={this.invoiceModal()}>Invoice</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="text" name="edit_invoice_no" value={this.state.edit_invoice_no} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        <Modal isOpen={this.state.remarkModal} toggle={this.remarkModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.remarks}>
            <ModalHeader toggle={this.remarkModal()}>Remark</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="textarea" name="edit_remarks" value={this.state.edit_remarks} rows={3} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        <Modal isOpen={this.state.emailModal} toggle={this.emailModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.email}>
            <ModalHeader toggle={this.emailModal()}>Email</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="text" name="email" value={this.state.email} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Send
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.orderDateModal} toggle={this.toggleOrderDateModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.updateOrderDate}>
            <ModalHeader toggle={this.toggleOrderDateModal()}>Order Date</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="date" name="order_dt" value={this.state.order_dt} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.scheduleModal} toggle={this.scheduleModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.schedule}>
            <ModalHeader toggle={this.scheduleModal()}>Schedule</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="date" name="schedule_date" value={this.state.schedule_date} onChange={this.scheduleHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Input type="select" name="schedule_slot" value={this.state.schedule_slot} onChange={this.scheduleHandler} required>
                      {this.state.schedule_option
                        .filter(x => x.available > 0)
                        .map(item => {
                          return (
                            <option key={item.slot_id} value={item.slot_id}>
                              {item.starttime + ' - ' + item.endtime}
                            </option>
                          )
                        })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.customerModal} toggle={this.customerModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }} size="lg">
          <ModalHeader toggle={this.customerModal()}>Edit Customer</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <Row>
                  <Label className="text-center" for="sortBy" md={2}>
                    Email
                  </Label>

                  <Col md={6}>
                    <Input className="ps-input-small" type="email" name="customer_email_search" value={this.state.customer_email_search} onChange={this.changeHandler} />
                  </Col>
                  <Col md={2}>
                    <Button className="ps-input-small" onClick={this.searchCustomerEmail}>
                      Search
                    </Button>
                  </Col>
                  <Col md={2}>
                    <Button className="ps-input-small" onClick={this.clearCustomerEmailList}>
                      Clear
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Table responsive hover className="ps-table tb-col-3">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.customer_email_list.length > 0 &&
                      this.state.customer_email_list.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.email}</td>
                            <td>
                              <Button className="ps-input-small" onClick={() => this.updateCustomerEmail(item.customer_id)}>
                                Update
                              </Button>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.state.addressModal} toggle={this.addressModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.address}>
            <ModalHeader toggle={this.addressModal()}>Address Info</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Name</Label>
                    <Input id="editaddress" name="name" value={this.state.editaddress.name} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input id="editaddress" name="email" value={this.state.editaddress.email} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Contact</Label>
                    <Input id="editaddress" name="contact" value={this.state.editaddress.contact} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Address</Label>
                    <Input id="editaddress" name="address" value={this.state.editaddress.address} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Unit</Label>
                    <Input id="editaddress" name="unit" value={this.state.editaddress.unit} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Postal Code</Label>
                    <Input id="editaddress" name="postal_code" value={this.state.editaddress.postal_code} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Country</Label>
                    <Input id="editaddress" name="country" value={this.state.editaddress.country} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Order Message</Label>
                    <Input id="editaddress" name="order_msg" value={this.state.editaddress.order_msg} onChange={this.addressHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.billingModal} toggle={this.billingModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.billing}>
            <ModalHeader toggle={this.billingModal()}>Billing Info</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Name</Label>
                    <Input id="editbilling" name="name" value={this.state.editbilling.name} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input id="editbilling" name="email" value={this.state.editbilling.email} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Contact</Label>
                    <Input id="editbilling" name="contact" value={this.state.editbilling.contact} onChange={this.addressHandler} />
                  </FormGroup>
                  {this.state.service_type !== 'Self Collection' && (
                    <>
                      <FormGroup>
                        <Label>Address</Label>
                        <Input id="editbilling" name="address" value={this.state.editbilling.address} onChange={this.addressHandler} />
                      </FormGroup>
                      <FormGroup>
                        <Label>Unit</Label>
                        <Input id="editbilling" name="unit" value={this.state.editbilling.unit} onChange={this.addressHandler} />
                      </FormGroup>
                      <FormGroup>
                        <Label>Postal Code</Label>
                        <Input id="editbilling" name="postal_code" value={this.state.editbilling.postal_code} onChange={this.addressHandler} />
                      </FormGroup>
                      <FormGroup>
                        <Label>Country</Label>
                        <Input id="editbilling" name="country" value={this.state.editbilling.country} onChange={this.addressHandler} />
                      </FormGroup>
                    </>
                  )}
                  <FormGroup>
                    <Label>Payment Mode</Label>
                    <Input id="editbilling" name="payment_mode" value={this.state.editbilling.payment_mode} onChange={this.addressHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Billing Message</Label>
                    <Input id="editbilling" name="billing_msg" value={this.state.editbilling.billing_msg} onChange={this.addressHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.dataModal} toggle={this.dataModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.paymentData}>
            <ModalHeader toggle={this.dataModal()}>Remark</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="text" name="payment_data" value={this.state.payment_data} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.referenceModal} toggle={this.referenceModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.paymentReference}>
            <ModalHeader toggle={this.referenceModal()}>Reference</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="text" name="payment_reference" value={this.state.payment_reference} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.paymentModal} toggle={this.paymentModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.payment}>
            <ModalHeader toggle={this.paymentModal()}>Payment</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="select" name="payment_type" value={this.state.payment_type} onChange={this.changeHandler} required>
                      <option></option>
                      {this.state.paymentList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      })}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Amount</Label>
                    <Input type="text" name="payment_amount" value={this.state.payment_amount} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Remark</Label>
                    <Input type="text" name="payment_data" value={this.state.payment_data} onChange={this.changeHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Reference</Label>
                    <Input type="text" name="payment_reference" value={this.state.payment_reference} onChange={this.changeHandler} />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="send_receipt" checked={this.state.send_receipt} onChange={this.checkHandler} />
                      Send Receipt
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        {this.state.delivery_ezp_list.length > 0 && this.state.ezpdetailModal == true && (
          <Modal isOpen={this.state.ezpdetailModal} toggle={this.ezpdetailModal()} className="modal-xl" centered style={{ fontSize: '0.85rem' }}>
            <Form>
              <ModalHeader toggle={this.ezpdetailModal()}>Order Detail</ModalHeader>
              <ModalBody>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <Card className="ps-card-display">
                      <CardBody>
                        <Row form>
                          <Col lg={6}>
                            <Label>Collection Point</Label>
                            <p>{this.state.epz_order_detail.pick_name}</p>
                          </Col>
                          <Col lg={6}>
                            <Label>Pickup Date</Label>
                            <p>{this.state.epz_order_detail.collect_date}</p>
                          </Col>
                          <Col lg={4}>
                            <Label>Pickup Postal Code</Label>
                            <p>{this.state.epz_order_detail.pick_code}</p>
                          </Col>
                          <Col lg={4}>
                            <Label>Pick Country</Label>
                            <p>{this.state.epz_order_detail.pick_country}</p>
                          </Col>
                          <Col lg={4}>
                            <Label>Unit</Label>
                            <p>{this.state.epz_order_detail.pick_unit}</p>
                          </Col>
                          <Col lg={4}>
                            <Label>Company</Label>
                            <p>{this.state.epz_order_detail.pick_company}</p>
                          </Col>
                          <Col lg={4}>
                            <Label>Contact</Label>
                            <p>{this.state.epz_order_detail.pick_contact}</p>
                          </Col>
                          <Col lg={4}>
                            <Label>Mobile</Label>
                            <p>{this.state.epz_order_detail.pick_mobile}</p>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label>Receiver Name*</Label>
                      <Input type="text" name="send_name" value={this.state.epz_order_detail.send_name} maxLength="35" readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Receiver Company</Label>
                      <Input type="text" name="send_company" value={this.state.epz_order_detail.send_company} maxLength="30" readOnly />
                    </FormGroup>

                    <FormGroup>
                      <Label>Receiver Contact*</Label>
                      <Input type="text" name="send_contact" value={this.state.epz_order_detail.send_contact} readOnly />
                    </FormGroup>

                    <FormGroup>
                      <Label>Receiver Mobile</Label>
                      <Input type="text" name="send_mobile" value={this.state.epz_order_detail.send_mobile} readOnly />
                    </FormGroup>

                    <FormGroup>
                      <Label>Receiver Unit*</Label>
                      <Input type="text" name="send_unit" value={this.state.epz_order_detail.send_unit} maxLength="10" readOnly />
                    </FormGroup>

                    <FormGroup>
                      <Label>Receiver Address*</Label>
                      <Input type="text" name="send_address" value={this.state.epz_order_detail.send_addr1} maxLength="35" readOnly />
                    </FormGroup>

                    <FormGroup>
                      <Label>Receiver State*</Label>
                      <Input type="text" name="send_state" value={this.state.epz_order_detail.send_state} maxLength="10" readOnly />
                    </FormGroup>

                    <Row form>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Receiver Postal Code</Label>
                          <Input type="text" name="send_code" value={this.state.epz_order_detail.send_code} readOnly />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Receiver Country</Label>
                          <Input type="text" name="send_country" value={this.state.epz_order_detail.send_country} readOnly />
                        </FormGroup>
                      </Col>
                    </Row>

                    <FormGroup>
                      <Label>Content</Label>
                      <Input type="text" name="content" value={this.state.epz_order_detail.content} maxLength="35" readOnly />
                    </FormGroup>

                    <FormGroup>
                      <Label>Content Value</Label>
                      <Input type="number" name="value" value={this.state.epz_order_detail.value} readOnly />
                    </FormGroup>

                    <Row form>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Width (cm)</Label>
                          <Input type="number" name="width" value={this.state.epz_order_detail.width} readOnly />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Length (cm)</Label>
                          <Input type="number" name="length" value={this.state.epz_order_detail.length} readOnly />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Height (cm)</Label>
                          <Input type="number" name="height" value={this.state.epz_order_detail.height} readOnly />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Package Weight* (kg)</Label>
                          <Input type="text" name="weight" value={this.state.epz_order_detail.weight} readOnly />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row form>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Reference</Label>
                          <Input type="text" name="order_id" value={this.state.epz_order_detail.reference} readOnly />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </ModalBody>
            </Form>
          </Modal>
        )}

        <Modal isOpen={this.state.deliveryezpModal} className="modal-xl" centered>
          <PosEasyParcelForm history={this.props.history} onToggleModal={this.deliveryezpModal} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.shipmentModal} toggle={this.shipmentModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.shipment}>
            <ModalHeader toggle={this.shipmentModal()}>Shipment Tracking</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="text" name="provider" value={this.state.edit_tracking.provider} onChange={this.shipmentHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Tracking No.</Label>
                    <Input type="text" name="tracking_no" value={this.state.edit_tracking.tracking_no} onChange={this.shipmentHandler} required />
                  </FormGroup>

                  <FormGroup>
                    <Label>Url</Label>
                    <Input type="text" name="url" value={this.state.edit_tracking.url} onChange={this.shipmentHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Remarks</Label>
                    <Input type="text" name="remarks" value={this.state.edit_tracking.remarks} onChange={this.shipmentHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.confirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.confirmModal()}>Cancel Order</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to cancel this order?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.confirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.status('Cancelled')}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.discountModal} toggle={this.discountModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.discount}>
            <ModalHeader toggle={this.discountModal()}>Discount</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="text" name="edit_discount" value={this.state.edit_discount} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.removeImageModal} toggle={this.removeImageModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.removeImageModal()}>Image</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to remove this image?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.removeImageModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.removeImage()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.imageModal} toggle={this.imageModal()} className="modal-md" centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.imageModal()}>Image</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12} style={{ textAlign: 'center' }}>
                <img style={{ width: 'inherit' }} src={this.state.selectedData} />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.imageModal()}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.uploadImageModal} toggle={this.uploadImageModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.uploadImageModal()}>Upload Image</ModalHeader>
          <Form onSubmit={this.uploadImage}>
            <ModalBody>
              <FormGroup>
                <Input type="file" name="b64image" onChange={this.imageChangeHandler} required />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-secondary" onClick={this.uploadImageModal()}>
                Close
              </Button>
              <Button className="theme-button theme-button-primary" type="submit">
                Upload
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Page>
    )
  }
}

export default PosOrderDetailPage
